import TextComboInput from "@shared/v2/TextComboInput";
import Typography from "@shared/v2/Typography";
import { SettingsSection } from "./types";

const ClosingConversionSettings = ({ onChange, productionGoals }: SettingsSection) => (
  <div className="tw-flex tw-flex-col tw-gap-[24px]">
    {/* @ts-expect-error props */}
    <Typography>
      Team defaults for <b>Closing Conversions</b> are used to provide new agents with a baseline set of
      values when they are setting their <b>Activity Goals</b> via Business Planning (Help Me Set My Goals)
    </Typography>

    <div className="tw-flex tw-gap-[24px]">
      {/* @ts-expect-error props */}
      <TextComboInput
        isRequired
        containerClassName="tw-flex-1"
        label="Calls to Past Client, Sphere, and Referrals Per 1 Unit Closed"
        name="callsPerClosed"
        onChange={onChange}
        value={productionGoals.goals.callsPerClosed}
        error={productionGoals.errors.callsPerClosed}
      />
      {/* @ts-expect-error props */}
      <TextComboInput
        isRequired
        containerClassName="tw-flex-1"
        label="Calls to Canceled/Expired Leads Per 1 Unit Closed"
        name="callsCanceledPerClosed"
        onChange={onChange}
        value={productionGoals.goals.callsCanceledPerClosed}
        error={productionGoals.errors.callsCanceledPerClosed}
      />
    </div>

    <div className="tw-flex tw-gap-[24px]">
      {/* @ts-expect-error props */}
      <TextComboInput
        isRequired
        containerClassName="tw-flex-1"
        label="Calls to Circle Prospecting Leads Per 1 Unit Closed"
        name="callsCirclePerClosed"
        onChange={onChange}
        value={productionGoals.goals.callsCirclePerClosed}
        error={productionGoals.errors.callsCirclePerClosed}
      />
      {/* @ts-expect-error props */}
      <TextComboInput
        isRequired
        containerClassName="tw-flex-1"
        label="Calls to Brivity/Web, Sign, and Team Leads Per 1 Unit Closed"
        name="callsWebSignTeamPerClosed"
        onChange={onChange}
        value={productionGoals.goals.callsWebSignTeamPerClosed}
        error={productionGoals.errors.callsWebSignTeamPerClosed}
      />
    </div>

    <div className="tw-flex tw-gap-[24px]">
      {/* @ts-expect-error props */}
      <TextComboInput
        isRequired
        containerClassName="tw-flex-1"
        label="Door Knocks Per 1 Unit Closed"
        name="doorKnocksPerClosed"
        onChange={onChange}
        value={productionGoals.goals.doorKnocksPerClosed}
        error={productionGoals.errors.doorKnocksPerClosed}
      />
      {/* @ts-expect-error props */}
      <TextComboInput
        isRequired
        containerClassName="tw-flex-1"
        label="Open Houses Per 1 Unit Closed"
        name="openHousesPerClosed"
        onChange={onChange}
        value={productionGoals.goals.openHousesPerClosed}
        error={productionGoals.errors.openHousesPerClosed}
      />
    </div>

    <div className="tw-flex tw-gap-[24px]">
      {/* @ts-expect-error props */}
      <TextComboInput
        isRequired
        containerClassName="tw-flex-1"
        label="Calls to FSBO Leads Per 1 Unit Closed"
        name="callsFsboPerClosed"
        onChange={onChange}
        value={productionGoals.goals.callsFsboPerClosed}
        error={productionGoals.errors.callsFsboPerClosed}
      />
      <span className="tw-flex-1" />
    </div>
  </div>
);

export default ClosingConversionSettings;
